import React, { useContext, useState, useEffect } from "react";
import "./Top1.css";
import { ContextEngine } from "../../engine/ContextEngine";
import { useProjects } from "../../engine/hooks/useProjects";


const Top = () => {
  const { context, loginUser, updateContext,undo,redo } = useContext(ContextEngine);
  const [isValid, setIsValid] = useState(false);
  const [projectsOpen, setProjectsOpen] = useState(false);
  
  const tenantId = context.user?.tenant_id; // or wherever you store it
  const { data: projects = [], isLoading, error: projectsError } = useProjects(tenantId);


   // Use the path from context
  const tenantIco = context.view?.ico;
  
  // 1. Find the index of the target table
  const tableId = "defaultTable";
  const unitIndex = context.context_units?.findIndex(u => u.id === tableId);
  
  // 2. Safely access the centralUnit object
  const centralUnit = unitIndex !== -1 ? context.context_units[unitIndex] : null;

  // 3. Handler to update the search value
  const handleSearchChange = (val) => {
    if (unitIndex !== -1) {
      // Direct path to the search property in the engine
      const path = `context_units.${unitIndex}.view.search`;
      updateContext(path, val);
    }
  }; 

  const currentProject = context.view?.selectedProject || "";
  const currentSection = context.view?.selectedSection || "";

  const projectLabel = projects.find(c => c.cont_id === currentProject)?.cont_value || "N/A";
  const sectionLabel = context.context_units.find(c => c.id === currentSection)?.label || "N/A";

  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const handleProjectChange = (id) => {
    updateContext("view.selectedProject", id);
      // 2. Wipe the children so the user is forced to pick a new valid path
    // updateContext("view.activeSection", null);
    updateContext("view.activeNamespace", null);
    updateContext("view.activeSheet", null);
  };

  const handleSectionChange = (id) => {
    updateContext("view.selectedSection", id);
    updateContext("view.activeNamespace", null);
    updateContext("view.activeSheet", null);
  };

  const user = context.user;

    useEffect(() => {
    if (!tenantIco) return;

    const verifyIcon = async () => {
      try {
        const response = await fetch(tenantIco, { method: 'HEAD' });
        
        // DEBUG: Check the console for this!
        console.log("Icon MIME Type:", response.headers.get("Content-Type"));
        
        if (response.ok) {
          setIsValid(true);
        } else {
          console.error("Icon found but returned error status:", response.status);
          setIsValid(false);
        }
      } catch (err) {
        console.error("Network error verifying icon:", err);
        setIsValid(false);
      }
    };

    verifyIcon();
  }, [tenantIco]); // Re-run if the icon path changes
  if (projectsError) return <div className="error-pill">Error loading projects</div>;
  return (
    <div className="top-panel"> 


      {/* Left: project/section labels */}
      <div className="top-left">
        {/* 3. Render the Icon if it exists, otherwise a default */}
        <div className="tenant-branding">
          {tenantIco ? (
            <img 
              src={tenantIco} 
              alt="Tenant" 
              crossOrigin="anonymous" // <--- Add this!
              style={{ width: '20px', height: '20px', objectFit: 'contain' }} 
            />
          ) : (
            <span>🏗️</span> // Default fallback icon
          )}
        </div>
        <span style={{ marginLeft: "8px" }}></span>
        <span>{projectLabel}</span>
        <span style={{ marginLeft: "8px" }}>{sectionLabel}</span>
      </div>
      <div className="top-center">
        <input
          type="text"
          placeholder="Search..."
          className="top-search-input"
          // Bind value to context so the input is "controlled"
          value={centralUnit?.view?.search || ""}
          onChange={(e) => {
            handleSearchChange(e.target.value);
          }}
        />
        {/* Optional: Clear button inside the search area */}
        {centralUnit?.view?.search && (
          <button onClick={() => handleSearchChange("")} className="clear-search-btn">
            ✕
          </button>
        )}
      </div>

      {/* -------- Right controls -------- */}
      <div className="top-right">
        {/* Project select */}
        <select value={currentProject} onChange={(e) => handleProjectChange(e.target.value)}>
          {projects.map(opt => (
            <option key={opt.cont_id} value={opt.cont_id}>{opt.cont_value}</option>
          ))}
        </select>

        {/* Section select */}
        <select value={currentSection} onChange={(e) => handleSectionChange(e.target.value)}>
          {context.context_units.filter(c => c.type === "section").map(opt => (
            <option key={opt.id} value={opt.id}>{opt.label}</option>
          ))}
        </select>

        {/* Create button */}
        <button className="create-btn" title="Create">
          <span className="plus-icon">+</span>
        </button>

        {/* User button */}
        <div className="user-btn-container">
          <button className={`user-btn ${user?.token ? "logged-in" : "logged-out"}`}
          onClick={() => setUserMenuOpen(!userMenuOpen)}
          >
            {user?.name ? user.name[0].toUpperCase() : "?"}
          </button>

          {userMenuOpen && (
            <div className="user-menu">
            {user ? (
              <>
                <div className="menu-header">Logged in as: <strong>{user.name}</strong></div>
                
                {/* Projects Submenu Trigger */}
                <div 
                  className="menu-item has-submenu" 
                  onMouseEnter={() => setProjectsOpen(true)}
                  onMouseLeave={() => setProjectsOpen(false)}
                >
                  <span>📁 Projects ▶</span>
                  {projectsOpen && (
                    <div className="submenu">
                      {/* 1. Filter the engine's units for projects only */}
                      {projects
                        .map((proj) => (
                          <div 
                            key={proj.cont_id} 
                            className={`menu-item ${context.view?.selectedProject === proj.cont_id ? "active-item" : ""}`}
                            onClick={() => {
                              handleProjectChange(proj.cont_id); // 🚀 Updates engine state
                              setProjectsOpen(false);      // Close submenu
                              setUserMenuOpen(false);      // Close main menu
                            }}
                          >
                            {/* 2. Show the real label and an indicator if it's the active one */}
                            {proj.cont_value} {context.view?.selectedProject === proj.cont_id && " ✅"}
                          </div>
                        ))}

                      {/* Fallback if no projects are found */}
                      {projects.length === 0 && (
                        <div className="menu-item disabled">No projects available</div>
                      )}
                    </div>
                  )}
                </div>

                <div className="menu-item" onClick={() => console.log("Account Settings")}>
                  ⚙️ Account Settings
                </div>
                <div className="menu-item" onClick={() => console.log("App Settings")}>
                  🛠️ App Settings
                </div>
                
                <div className="menu-divider"></div>
                
                <div className="menu-item logout" onClick={() => loginUser(null)}>
                  Logout
                </div>
              </>
              ) : (
                <div className="login-menu">
                  <div className="menu-header">Select Account</div>
                  
                  {/* Option 1: Admin */}
                  <div className="menu-item user-option" onClick={() => loginUser({ id: "u01", name: "Admin User", role: "admin" })}>
                    <span className="user-icon admin">A</span>
                    <div className="user-info">
                      <div className="user-name">Admin User</div>
                      <div className="user-role">Full Access</div>
                    </div>
                  </div>

                  {/* Option 2: Viewer */}
                  <div className="menu-item user-option" onClick={() => loginUser({ id: "u99", name: "Guest User", role: "viewer" })}>
                    <span className="user-icon viewer">G</span>
                    <div className="user-info">
                      <div className="user-name">Guest User</div>
                      <div className="user-role">Read Only</div>
                    </div>
                  </div>

                  <div className="menu-divider"></div>
                  
                  {/* Option 3: "Add New" style button */}
                  <div className="menu-item add-account" onClick={() => console.log("Open login modal")}>
                    ➕ Add another account...
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

    </div>
  );
};

export default Top;
